import {
  title,
  mrAuto,
  mlAuto,
  grayColor
} from "../../../material-kit-pro-react";
import { createStyles } from "@material-ui/core";

const workStyle = createStyles({
  mrAuto,
  mlAuto,
  section: {
    padding: "70px 0"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "center"
  },
  description: {
    color: grayColor[0],
    textAlign: "center"
  },
  textCenter: {
    textAlign: "center"
  },
  textArea: {
    marginRight: "15px",
    marginLeft: "15px"
  }
});

export default workStyle;
